import * as React from 'react';
import { useContext } from 'react';
import TopNavigation from '@components/TopNavigation';
import Footer from '@components/Footer';
import { GlobalStateContext } from '@context/context';
import {
  AcademyBanner,
  DealfrontAIBanner,
  WiredMindsBanner,
} from '@components/Banners';
import { useI18next } from 'gatsby-plugin-react-i18next';
import './style.scss';

const Layout = ({
  children,
  classes = '',
  navType,
  progressBar,
  LogoComponent,
  topNavClasses = '',
}) => {
  const { path } = useI18next();

  const { showInfoBox } = useContext(GlobalStateContext);

  const isPlaybooksPage = path.startsWith('/resources/playbooks/');
  const isAcademyPage = path.startsWith('/resources/academy/');
  const isDealfrontAIPage = path.startsWith('/platform/features/ai-insights/');
  const isWiredMindsBlog =
    path.startsWith(
      '/resources/press-releases/dealfront-acquires-wiredminds/'
    ) ||
    path.startsWith(
      '/de/resources/press-releases/dealfront-uebernimmt-wiredminds/'
    );

  return (
    <>
      {showInfoBox && isAcademyPage && <AcademyBanner />}
      {!isDealfrontAIPage && !isAcademyPage && showInfoBox && (
        <DealfrontAIBanner />
      )}
      <TopNavigation
        navType={navType}
        progressBar={progressBar}
        LogoComponent={LogoComponent}
        classes={topNavClasses}
      />
      <main className={classes}>{children}</main>
      <Footer />
    </>
  );
};

export default Layout;
